import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { inputCls, Panel, btnPrimary, btnSecondary, errMsg } from "../admin/ui";
import TelegramLink from "./TelegramLink";

const CHANNELS = [["website", "Website saja"], ["telegram", "Telegram saja"], ["both", "Website + Telegram"], ["off", "Nonaktif"]];
const DAYS = ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab", "Min"];
const chip = (on) => `px-3 py-1.5 rounded-full text-xs border transition-colors ${on ? "bg-[#D4AF37] text-[#101114] border-[#D4AF37]" : "border-[#35353B] text-[#A8A8AD] hover:border-[#D4AF37]"}`;
const toggle = (arr, v) => (arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v]);

export default function NotificationSettings({ games }) {
  const [p, setP] = useState(null);
  const [servers, setServers] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/notification-prefs").then((r) => setP(r.data)); api.get("/servers").then((r) => setServers(r.data)); }, []);
  if (!p) return <div className="text-[#A8A8AD]">Memuat...</div>;
  const set = (k, v) => setP({ ...p, [k]: v });
  const tgNeeded = ["telegram", "both"].includes(p.channel) && !p.telegram_linked;

  const save = async () => {
    setSaving(true);
    try {
      const body = { channel: p.channel, quiet_enabled: p.quiet_enabled, quiet_start: p.quiet_start, quiet_end: p.quiet_end, tz: p.tz,
        active_days: p.active_days, game_ids: p.game_ids, server_ids: p.server_ids };
      const r = await api.put("/notification-prefs", body);
      setP({ ...p, ...r.data }); toast.success("Preferensi notifikasi disimpan");
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  const test = async () => {
    try {
      const r = (await api.post("/notification-prefs/test")).data;
      if (r.note) toast.info(r.note);
      if (r.website) toast.success("Notifikasi website terkirim (cek lonceng)");
      if (r.telegram === true) toast.success("Pesan tes Telegram terkirim");
      else if (r.telegram) toast.error(`Telegram: ${r.telegram}`);
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="notif-settings" className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Panel title="Saluran Notifikasi">
        <div className="flex flex-wrap gap-2 mb-5">{CHANNELS.map(([k, l]) => {
          const off = ["telegram", "both"].includes(k) && !p.telegram_linked;
          return <button key={k} data-testid={`notif-channel-${k}`} disabled={off} title={off ? "Hubungkan Telegram terlebih dahulu" : ""} onClick={() => set("channel", k)} className={`${chip(p.channel === k)} disabled:opacity-35 disabled:cursor-not-allowed`}>{l}</button>;
        })}</div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37] mb-2">Telegram</div>
        <TelegramLink prefs={p} onChange={(d) => setP({ ...p, ...d })} />
        {tgNeeded && <p data-testid="notif-tg-needed" className="text-xs text-[#F2D98D] mt-2">Hubungkan Telegram dulu sebelum menyimpan pilihan ini.</p>}
        <p className="text-[11px] text-[#A8A8AD] mt-3">Telegram bersifat opt-in: notifikasi Telegram hanya dikirim setelah Anda menghubungkan bot dan memilihnya di atas.</p>
      </Panel>
      <Panel title="Jam Tenang & Hari Aktif">
        <label className="flex items-center gap-2 text-sm text-[#F5F3ED] mb-3 cursor-pointer"><input data-testid="notif-quiet-toggle" type="checkbox" checked={p.quiet_enabled} onChange={(e) => set("quiet_enabled", e.target.checked)} className="accent-[#D4AF37]" /> Aktifkan Quiet Hours</label>
        <div className="grid grid-cols-3 gap-3 mb-4">
          <input data-testid="notif-quiet-start" type="time" value={p.quiet_start} onChange={(e) => set("quiet_start", e.target.value)} className={inputCls} />
          <input data-testid="notif-quiet-end" type="time" value={p.quiet_end} onChange={(e) => set("quiet_end", e.target.value)} className={inputCls} />
          <select data-testid="notif-tz" value={p.tz} onChange={(e) => set("tz", e.target.value)} className={inputCls}>{p.timezones.map((z) => <option key={z} value={z}>{z}</option>)}</select>
        </div>
        <div className="text-xs text-[#A8A8AD] mb-2">Hari aktif notifikasi Telegram</div>
        <div className="flex flex-wrap gap-2">{DAYS.map((d, i) => <button key={d} data-testid={`notif-day-${i}`} onClick={() => p.active_days.length > 1 || !p.active_days.includes(i) ? set("active_days", toggle(p.active_days, i)) : null} className={chip(p.active_days.includes(i))}>{d}</button>)}</div>
        <p className="text-[11px] text-[#A8A8AD] mt-3">Selama jam tenang atau di luar hari aktif, notifikasi Telegram ditunda sampai waktu aktif berikutnya. Notifikasi website tetap masuk.</p>
      </Panel>
      <Panel title="Game & Server yang Diminati">
        <p className="text-[11px] text-[#A8A8AD] mb-3">Kosongkan untuk menerima semua game/server.</p>
        <div className="flex flex-wrap gap-2 mb-4">{games.map((g) => <button key={g.id} data-testid={`notif-game-${g.id}`} onClick={() => set("game_ids", toggle(p.game_ids, g.id))} className={chip(p.game_ids.includes(g.id))}>{g.name}</button>)}</div>
        {p.game_ids.length > 0 && <div className="max-h-48 overflow-y-auto flex flex-wrap gap-2">{servers.filter((s) => p.game_ids.includes(s.game_id)).map((s) => (
          <button key={s.id} data-testid={`notif-server-${s.id}`} onClick={() => set("server_ids", toggle(p.server_ids, s.id))} className={chip(p.server_ids.includes(s.id))}>{s.name}</button>))}</div>}
      </Panel>
      <div className="flex flex-wrap gap-3 items-start">
        <button data-testid="notif-save-btn" onClick={save} disabled={saving || tgNeeded} className={btnPrimary}>{saving ? "Menyimpan..." : "Simpan Preferensi"}</button>
        <button data-testid="notif-test-btn" onClick={test} className={btnSecondary}>Test Notification</button>
      </div>
    </div>
  );
}
